import type { ReactNode } from 'react';
import type { To } from 'react-router';

import { useTranslation } from 'react-i18next';

import { LinkButton } from '~/components';

import { footerStyle } from './WizardFooter.css';

type Props = {
  backTo: To;
  children?: ReactNode;
};

export const WizardFooter = ({ backTo, children }: Props) => {
  const { t } = useTranslation(['clients']);

  return (
    <div className={footerStyle}>
      <LinkButton emphasis="secondary" icon="ArrowLeft" to={backTo}>
        {t('clients:create.previous')}
      </LinkButton>

      {children}
    </div>
  );
};
